import { reactive, readonly } from 'vue';

/**
 * Quem abre a gaveta de assinatura: o botão do compositor, a ficha do
 * contato, Assinaturas, Contratos, a página da minuta e o "Gerar documentos".
 * A gaveta só ouve "abra para esta conversa" — e, vindo de minutas, "com
 * elas já escolhidas" (`minutaId` ou `minutaIds`, na ordem de leitura).
 */
const estado = reactive({ aberta: false, conversaId: null, minutaIds: [] });

export function abrirGavetaDeAssinatura(
  conversaId,
  { minutaId = null, minutaIds = [] } = {}
) {
  estado.conversaId = conversaId;
  estado.minutaIds = minutaId ? [minutaId] : [...minutaIds];
  estado.aberta = true;
}

export function fecharGavetaDeAssinatura() {
  estado.aberta = false;
}

export function useGavetaDeAssinatura() {
  return readonly(estado);
}
